import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
type FormTextFieldProps = Omit<TextFieldProps, "value" | "onChange"> & {
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export const FormTextField: React.FC<FormTextFieldProps> = ({
  label,
  value,
  onChange,
  type = "text",
  multiline = false,
  rows = 1,
  ...rest
}) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      type={type}
      variant="outlined"
      fullWidth
      margin="normal"
      multiline={multiline}
      rows={rows}
      {...rest}
      sx={{
        "& .MuiFormLabel-asterisk": {
          color: "red", 
        },
      }}
      
    />
  );
};
